import { Box, CircularProgress, Dialog, DialogContent, DialogTitle, IconButton, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import React, { memo, useEffect, useState } from 'react';
import configServ from '../../services/config';
import { AutoStories, Cancel, PlayCircle } from '@mui/icons-material';

// FUNCTION
const VideosPopup = ({ open, handleClose, prescriptionId }) => {
    //#region code
    const [loading, setLoading] = useState(true);
    const [videos, setVideos] = useState([]);

    const fetchVideos = async () => {
        try {
            setLoading(true);
            const dataToSend = {
                prescription_id: prescriptionId
            }
            const res = await configServ.getSolutionsByPrescription(dataToSend);
            if (res.status === 200) {
                setVideos(res.data);
            }
            else {
                setVideos([]);
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (prescriptionId !== null) {
            fetchVideos();
        }
    }, [prescriptionId]);

    const closeVideos = () => {
        setLoading(true);
        setVideos([]);
        handleClose();
    }

    //#endregion

    return (
        <>
            <Dialog
                open={open}
                onClose={closeVideos}
                fullWidth
                maxWidth={'md'}
            >
                <DialogTitle sx={{ padding: 0 }}>
                    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography variant='h6' color={'primary'} fontWeight={700} ml={5}>Solutions</Typography>
                        <IconButton onClick={closeVideos} sx={{ fontSize: '36px' }}>
                            <Cancel fontSize='36px' color='error' />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent>
                    {
                        loading ?
                            <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                <CircularProgress />
                            </Box>
                            :
                            <Box>
                                {videos.length > 0 ? (
                                    <List>
                                        {videos.map((item, index) => (
                                            <ListItem key={index}>
                                                <ListItemIcon>
                                                    <AutoStories color="primary" />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <a
                                                            // href={item.item_name}
                                                            target="_blank"
                                                            style={{
                                                                textDecoration: 'none', color: 'inherit',
                                                                '&:hover': {
                                                                    textDecoration: 'underline',
                                                                    color: 'blue',
                                                                },
                                                            }}
                                                        >
                                                            {item.item_name || ''}
                                                        </a>
                                                    }
                                                    primaryTypographyProps={{
                                                        variant: 'body1',
                                                        fontWeight: 'bold',
                                                    }}
                                                />

                                            </ListItem>
                                        ))}
                                    </List>
                                ) : (
                                    <Box
                                        display="flex"
                                        justifyContent="center"
                                        alignItems="center"
                                        height="100%"
                                        minHeight="150px"
                                    >
                                        <Typography variant="h6" color="error" textAlign="center">
                                            No solution found.
                                        </Typography>
                                    </Box>
                                )}
                            </Box>
                    }
                </DialogContent>
            </Dialog>
        </>
    )
}

export default memo(VideosPopup);
